import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
/**
 * StatStrip — horizontal row of metric tiles. Replaces ad-hoc inline
 * grids on Scorecard glance, Dossier hero stats, the Today briefing
 * "active surveillance" rail. Each `Stat` carries a small label and a
 * big numeric value; the strip pins them in a single border-rounded
 * card with vertical dividers between columns.
 *
 * Caller controls the number of columns (1..6); CSS grid handles the
 * even distribution.
 */
export function StatStrip({ items, className, }) {
    // `grid-template-columns: repeat(0, …)` is invalid CSS — render
    // nothing rather than emit a broken style. Callers that want a
    // placeholder should pass at least one item.
    if (items.length === 0)
        return null;
    return (_jsx("div", { className: cn('grid overflow-hidden rounded-2 border border-[var(--color-line)] bg-[var(--color-surface)]', className), style: { gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }, children: items.map((it, i) => (_jsxs("div", { className: cn('px-4.5 py-4', i < items.length - 1 && 'border-e border-[var(--color-line)]'), children: [_jsx("div", { className: "font-mono text-2xs uppercase tracking-[0.14em] text-[var(--color-ink-muted)]", children: it.label }), _jsx("div", { className: "mt-1 text-2xl font-semibold tracking-[-0.01em] text-[var(--color-ink)] tabular-nums", children: it.value })] }, it.key ?? i))) }));
}
